// Module Name
export const name = 'contract';

export const typeContract = {
    GET_GROUPS: `${name}/GET_GROUPS`,
    GET_GROUP_DETAILS: `${name}/GET_GROUP_DETAILS`,
    GET_COLLABS: `${name}/CREATE_COLLABS`,
    SEARCH_COLLABS: `${name}/SEARCH_COLLABS`,
    SEARCH_COLLABS_NO_CACHE: `${name}/SEARCH_COLLABS_NO_CACHE`,
    GET_ROLES: `${name}/GET_ROLES`,
    CREATE_GROUP: `${name}/CREATE_GROUP`,
    UPDATE_GROUP: `${name}/UPDATE_GROUP`,
    DELETE_GROUP: `${name}/DELETE_GROUP`,
    ADD_USERS_TO_GROUP: `${name}/ADD_USERS_TO_GROUP`,
    ADD_USERS_TO_GROUPS: `${name}/ADD_USERS_TO_GROUPS`,
    EDIT_USERS_ROLES_IN_GROUP: `${name}/EDIT_USERS_ROLES_IN_GROUP`,
    CREATE_USER: `${name}/CREATE_USER`,
    DELETE_USER: `${name}/DELETE_USER`,
    SEND_NEW_INVITE_EMAIL: `${name}/SEND_NEW_INVITE_EMAIL`,
    EXPORT_CONTRACT_USERS: `${name}/EXPORT_CONTRACT_USERS`,
    EXPORT_CONTRACT_GROUP_USERS: `${name}/EXPORT_CONTRACT_GROUP_USERS`,
    HAS_UNSIGNED_CONTRACT: `${name}/HAS_UNSIGNED_CONTRACT`,
    GET_CONTRACT_TEXT: `${name}/GET_CONTRACT_TEXT`,
    GET_CONTRACT_INFO: `${name}/GET_CONTRACT_INFO`,
};
